var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaverseSoftwareDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    id: "Metaversesoftwaredeveloper",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M1129.57,70.73c-57.2,0-89.44,64.72-57,110.35l8.19,30c6.69,24.48,26.43,40.49,47.22,40.49h2.11c21.37,0,41.68-16.48,48.58-41.77l7.84-28.75C1218.92,135.57,1186.92,70.73,1129.57,70.73Z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.18,
    height: 94.84,
    x: 1099.48,
    y: 220.17,
    fill: "#25d8e6",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#224346",
    d: "M1125 204.76a5 5 0 01-4.84-6l5-23.11a2 2 0 013.91.85l-5 23.11c-.15.68.52 1.29.94 1.15l8.44-.12a2 2 0 010 4zM1105.84 167.2a5.95 5.95 0 105.94 5.94A5.95 5.95 0 001105.84 167.2zM1151 167.2a5.95 5.95 0 106 5.94A5.94 5.94 0 001151 167.2zM1089.87 153.65c-2.25 2.13-4.12 5.28-3.41 6.09 1.11 1.28 6.67-5.57 14.68-5.06 5.49.35 9 4 12.35 1.87.21-.12 1.83-1.15 1.77-2.44C1115.1 150.68 1098.39 145.56 1089.87 153.65zM1166.48 153.65c-8.53-8.1-25.23-3-25.4.46 0 1.29 1.57 2.32 1.77 2.44 3.39 2.09 6.86-1.52 12.35-1.87 8-.51 13.57 6.34 14.69 5.06C1170.59 158.93 1168.73 155.78 1166.48 153.65z",
    className: "color262246 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M1098.74,242.62a2,2,0,1,1,2.55-3.08,43.62,43.62,0,0,0,56.4-.33,2,2,0,0,1,2.59,3A47.63,47.63,0,0,1,1098.74,242.62Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M1120.12,279.69l-108.76,4.88A87.53,87.53,0,0,0,931,348.24L827.79,714.08,938,758.67l109.23-352Q1083.65,343.2,1120.12,279.69Z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00eafd",
    d: "M1120.12,279.69l-128,2a74.81,74.81,0,0,0-70.48,53.27L843.82,594,982,653.61l50.29-238.43Z",
    className: "colorfdc500 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M802.22 371.14l137 363.93C947.82 777.34 919 814 886.81 816.7c-24.09 2-49.69-14.89-61-42.29q-45.24-187.86-90.49-375.73zM1135.28 282.51l111.44 9.39A75.84 75.84 0 011313.64 348l103 387.1-118 23.6-98.54-362z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M1533.84,399.34,1300.4,735.07c-9,33.86,8,69.11,38.69,82.62,33,14.51,73.4.22,90.49-33.45l151.47-335.07Z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M1210,677.36q25,86.42,49.94,172.84a106.22,106.22,0,0,1-26.61,104.29L983.49,1206.55c-9.21,217.51-67.93,427.32-172,622.5l-74.57-24.48q46.43-316,92.83-632A144,144,0,0,1,864,1098.5l229.32-261.14,2-123.93Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M1002.49,677.36,990.08,739,739.53,915.63a122.43,122.43,0,0,0-38.88,155Q848,1364.14,995.29,1657.69l59.74-51.81c-26.58-198.47-93.21-385.51-197.08-553.44l293.77-178.36-30.15-168.91Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M826.11 1787.52l-17.7 160.33L496.94 1796.7c-.73-2.75-5.74-23.14 6.94-39.72 12.23-16 35.83-21.76 57.28-12.87A574.65 574.65 0 00754 1758.67zM1042.15 1585.53l138.9 82L915.32 1889.43c-1.3-.25-26-5.4-34.61-28.54-6.55-17.68-.86-38.26 14.37-51.06a635.23 635.23 0 0091.14-170.39z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00eafd",
    d: "M1125.53,279.69l135.64,10.11A73.87,73.87,0,0,1,1326,341L1397,562.61l-145.06,59.65L1223.42,442Z",
    className: "colorfdc500 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1120.12,279.69,972.05,315.28q5.7,214.92,11.41,429.84a558,558,0,0,0,243.34-8.64q18.67-214.4,54.1-426.92Z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M1099.48,279.69c5.11,28.67,30.76,39,46.92,29.49,8.75-5.15,13.82-15.54,13.26-26.95C1159.66,282.23,1137.22,253.51,1099.48,279.69Z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00eafd",
    d: "M1100.57 284.39Q1045.4 515 990.24 745.63L900.74 802q18-86.13 36-172.26 11.94-160.58 23.89-321.15zM1159.66 285.28L1159 668.36l60.37 321.3a193.91 193.91 0 00142.35-91.51l-77.28-284.7q3.74-152.45 7.46-304.88z",
    className: "colorfdc500 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00eafd",
    d: "M1099.48 255.67c-8.86.45-13.15 4-14.85 5.72-3.25 3.27-9 15.82-10.68 19.91q2.28 47.64 4.57 95.28l22-91.3zM1159.7 259.61l-.72 150 35.2-124.31c-11-8.4-13.2-15.4-16.52-18.89C1174.8 263.38 1169.66 260.12 1159.7 259.61z",
    className: "colorfdc500 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M796.76,1397.29q-27.32,143.93-54.62,287.84l153.2,38q40.67-207.42,81.34-414.84Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M749.3,1167.53l171.12,415.92,148.45-79.3L936.62,1198.33Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M754 1688.08l-22.75 72.1s14.24 4.94 32.54 35.44S823.18 1814 823.18 1814l42.87-98.2zM950.08 1567.61l33.46 79.28s9.39-14.63 46-3.11 49.41-36.53 49.41-36.53l-25.63-94.8z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M957.63 993.92a2 2 0 01-1.93-2.52l38-141.9a2 2 0 013.87 1l-38 141.89A2 2 0 01957.63 993.92zM809.84 1310.25a2 2 0 01-2-2.18l11-121a117.65 117.65 0 0123.29-60.29l34.3-45.44a2 2 0 013.2 2.42l-34.31 45.43a113.69 113.69 0 00-22.5 58.25l-11 121A2 2 0 01809.84 1310.25zM920.42 1585.45a2 2 0 01-2-2.38l56.22-285.35a2 2 0 013.93.78l-56.23 285.34A2 2 0 01920.42 1585.45zM983.48 1208.55c-1.07 0 1.71 2.08-36.25-30.28a2 2 0 012.6-3L984.78 1205A2 2 0 01983.48 1208.55z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M1070.62,185.89l3.33-52.36s18.53.51,25.53-8.64,15.78-34.57,15.78-34.57,35.89-8.64,43.72,17.79,29.33,45.08,29.33,45.08l-4.89,29.59,16.64,3.11,6.07-26s16.95-13.49,16.95-29.42-16.93-20.33-31-48.8-62.12-31.86-80.3-18.31c-37-16.93-73.81,23.6-70.37,56.27.56,5.28,2.45,13.52,9.16,22.7l3.72,43.55Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M1080.73,175.52c-4.7-9-14.72-13-22.39-9s-10.07,14.55-5.37,23.52,14.72,13,22.38,9S1085.43,184.49,1080.73,175.52Z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#224346",
    d: "M1070,194.6a9.12,9.12,0,0,1-4.9-13.51h-6.2a2,2,0,0,1,0-4h11.75a2,2,0,0,1,.65,3.89,5.16,5.16,0,0,0,0,9.83A2,2,0,0,1,1070,194.6Z",
    className: "color262246 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M1200.58,166.53c-7.66-4-17.69,0-22.38,9s-2.3,19.5,5.37,23.52,17.69,0,22.39-9S1208.25,170.55,1200.58,166.53Z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#224346",
    d: "M1187.66,190.81a5.16,5.16,0,0,0,0-9.83,2,2,0,0,1,.66-3.89h11.75a2,2,0,0,1,0,4h-6.2A9.12,9.12,0,0,1,1189,194.6,2,2,0,0,1,1187.66,190.81Z",
    className: "color262246 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M798.67 1923c-.73 0 12.43 6.37-280.77-138.5a2 2 0 011.78-3.58l279.88 138.28A2 2 0 01798.67 1923zM909.08 1869.13a2 2 0 01-1.31-3.51l232-200.3a2 2 0 112.61 3C893.56 1883.19 910.24 1869.13 909.08 1869.13zM661.27 1792.49l-13.54-23.82a1.42 1.42 0 00-2.55.2l-6 15.87a5.41 5.41 0 01-10.07.11L622 1767.27a1.41 1.41 0 00-2.52-.19l-7.07 12a5.41 5.41 0 01-10-2.14l-2.42-21.39a2 2 0 114-.45l2.42 21.39a1.41 1.41 0 002.61.56l7.07-12a5.41 5.41 0 019.67.72l7.12 17.58a1.4 1.4 0 002.62 0l6-15.86a5.41 5.41 0 019.76-.75l13.55 23.81a1.41 1.41 0 002.62-.51l2.23-16.54a5.41 5.41 0 019.93-2.17l11.35 18a1.41 1.41 0 002.59-.65l1.77-23.28a2 2 0 114 .3l-1.76 23.28a5.41 5.41 0 01-10 2.48l-11.35-17.94a1.41 1.41 0 00-2.59.57l-2.23 16.53A5.41 5.41 0 01661.27 1792.49zM955.66 1778.31c-2.43 0-1.27.31-28-16.29a2 2 0 112.11-3.4l24.66 15.32a2.28 2.28 0 003.31-2.83l-9.17-21.74a6.29 6.29 0 017.75-8.41l25.08 8.21a2.28 2.28 0 002.67-3.33l-12.81-21.66a6.29 6.29 0 017.12-9.25l28.84 8.16a2.28 2.28 0 002.44-3.58l-28.13-36.89a2 2 0 113.18-2.43l28.13 36.9a6.28 6.28 0 01-6.7 9.85l-28.85-8.16a2.29 2.29 0 00-2.59 3.36l12.82 21.66a6.28 6.28 0 01-7.36 9.17l-25.09-8.21a2.28 2.28 0 00-2.81 3.06l9.17 21.74A6.31 6.31 0 01955.66 1778.31z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M802.47,388.23l4.64-40.06a24.43,24.43,0,0,0-3.3-15.35L793,314.69A29.19,29.19,0,0,0,773.19,301l-17.49-3.21-26.54-27.66c-2.24-2.34,1.52-.44-61.24-25-5.29-.71-10.4,1.43-12.88,5.42-3.36,5.41-1.54,13.67,5.08,18l51.52,25.08,19,22.63c-7.78-5.75-17.67-3.85-21.44,1.95-2.62,4-2.23,9.87.76,14.74-7-5.1-16.39-3-20,3.05-2.85,4.76-1.9,11.62,2.71,16.27A15,15,0,0,0,682,377.3l41.18,38.22a38,38,0,0,0,41.69,0Z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M766.38,382.1a2,2,0,0,1-1.57-.76c-11.68-14.81-8.24-31.72-4.39-41.77l-14.6,12.56c-12.6,8-26.42-5-19.94-17.68l28.21-37.91a2,2,0,0,1,3.22,2.4l-28,37.62a9.89,9.89,0,0,0,1.48,10.92,10.08,10.08,0,0,0,12.71,1.44l21.62-18.63a2,2,0,0,1,3,2.6c-.17.25-16.22,25.55-.11,46A2,2,0,0,1,766.38,382.1Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M722.63,399.54a8.88,8.88,0,0,1-3.31-.45L686,378.5a2,2,0,0,1,2.1-3.41l32.93,20.36c7.73.83,14.58-4.51,11.56-12.49a2,2,0,0,1,2.18-2.68c8.59,1.36,13.59-7,10-14.29a2,2,0,0,1,2.62-2.71c5.3,2.36,10.16-2,9.24-7.42a2,2,0,0,1,1.63-2.31c5.15-.74,2.77,15.16-8.64,14.31,1.71,8.18-3.35,16.07-12.48,16.51C738.66,393.23,731.42,399.54,722.63,399.54Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M746.55 367.1c-1.14 0 1.54 2-37.93-32.78a2 2 0 012.65-3l36.6 32.28A2 2 0 01746.55 367.1zM734.48 384.25c-.94 0 2.52 2.28-43-30.49a2 2 0 012.33-3.24l41.83 30.11A2 2 0 01734.48 384.25zM736.76 324.27c-1.12 0-.9-.07-7.56-6.73a2 2 0 012.83-2.83l6.15 6.15A2 2 0 01736.76 324.27z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25d8e6",
    d: "M1505.37,448.4l-4.64-40.07A24.44,24.44,0,0,1,1504,393l10.83-18.13a29.21,29.21,0,0,1,19.8-13.75l17.49-3.21,26.54-27.65c2.24-2.34-1.53-.44,61.24-25.05,5.28-.71,10.4,1.43,12.88,5.42,3.36,5.41,1.53,13.68-5.09,18l-51.51,25.08-19,22.62c7.77-5.74,17.67-3.85,21.44,1.95,2.61,4,2.23,9.88-.77,14.74,7-5.1,16.39-3,20,3,2.84,4.77,1.9,11.62-2.71,16.27a15,15,0,0,1,10.67,25.17l-41.18,38.21a38,38,0,0,1-41.68,0Z",
    className: "colore67925 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M1541.46,442.26a2,2,0,0,1-1.57-3.23c16.1-20.43.06-45.72-.1-46a2,2,0,0,1,3-2.6l21.86,18.81a9.69,9.69,0,0,0,13.77-12.82l-27.87-37.34a2,2,0,1,1,3.21-2.39l28,37.62c6.89,13.31-7.5,25.74-19.53,18.14l-14.83-12.74c3.85,10,7.28,27-4.39,41.77A2,2,0,0,1,1541.46,442.26Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M1585.21,459.7c-8.85,0-16-6.35-14.5-15.17-9.14-.45-14.18-8.35-12.48-16.5-11.52.77-13.73-15.06-8.64-14.31a2,2,0,0,1,1.64,2.31c-.94,5.54,4.13,9.78,9.24,7.41a2,2,0,0,1,2.61,2.71c-3.58,7.25,1.24,15.64,10,14.29a2,2,0,0,1,2.18,2.69c-3,7.84,3.73,13.34,11.56,12.49l32.93-20.36a2,2,0,1,1,2.1,3.4l-33.3,20.59A8.71,8.71,0,0,1,1585.21,459.7Z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006068",
    d: "M1561.29 427.27a2 2 0 01-1.32-3.5l36.6-32.29a2 2 0 012.65 3C1559.44 429.56 1562.39 427.27 1561.29 427.27zM1573.36 444.42a2 2 0 01-1.17-3.63L1614 410.68a2 2 0 112.33 3.24C1571.13 446.49 1574.34 444.42 1573.36 444.42zM1571.07 384.43a2 2 0 01-1.41-3.41l6.15-6.15a2 2 0 112.82 2.83C1572 384.3 1572.19 384.43 1571.07 384.43zM919.68 685.05a2 2 0 01-1.87-1.29l-25.33-67.24a2 2 0 113.75-1.41l25.32 67.24A2 2 0 01919.68 685.05zM936.69 631.72a2 2 0 01-2-2.15l20.19-271.39a2 2 0 114 .3L938.68 629.87A2 2 0 01936.69 631.72zM1282.42 613.4l6.09-248.85a2 2 0 014 .1l-6.09 248.85A2 2 0 011282.42 613.4zM1038.87 384.64A2 2 0 011037 382l35.08-101.34a2 2 0 113.78 1.31l-33.63 97.16 32-13.07a2 2 0 111.51 3.7C1037.21 385.48 1039.47 384.64 1038.87 384.64zM1194.18 395.49c-.76 0 1.93 1.4-30.73-17.22a2 2 0 012-3.48l26.75 15.26V285.28a2 2 0 014 0V393.49A2 2 0 011194.18 395.49zM1323.06 698.83a2 2 0 01-1.61-3.2l58.88-79a2 2 0 013.21 2.39C1320.8 703.2 1324.57 698.83 1323.06 698.83z",
    className: "color68003c svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1133.87,
    cy: 219.96,
    fill: "#224346",
    rx: 6.17,
    ry: 9.83,
    className: "color262246 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.01,
    height: 47.12,
    x: 1071.81,
    y: 144.72,
    fill: "#00eafd",
    rx: 8.26,
    className: "colorfdc500 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.62,
    height: 12.2,
    x: 1174.61,
    y: 150.99,
    fill: "#00eafd",
    rx: 4,
    className: "colorfdc500 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.62,
    height: 12.2,
    x: 1047.01,
    y: 150.99,
    fill: "#00eafd",
    rx: 4,
    className: "colorfdc500 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.88,
    height: 41.28,
    x: 1078.79,
    y: 144.72,
    fill: "#21929b",
    rx: 8.26,
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1595.29,1276.91H1356a77,77,0,0,1-25.94-149.46,92,92,0,0,1,171-53c41-18.65,89.12,5,99.56,48.8a76.93,76.93,0,0,1-5.37,153.68Zm-173.38-239.6a84.12,84.12,0,0,0-83.6,92.55,4,4,0,0,1-2.8,4.21A69,69,0,0,0,1356,1268.91h239.27a68.93,68.93,0,0,0,2-137.83,4,4,0,0,1-3.81-3.25c-8-41.64-54.1-64.36-92.16-44.61a4,4,0,0,1-5.36-1.65A84,84,0,0,0,1421.91,1037.31Z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 83.99,
    height: 157.98,
    x: 1491.43,
    y: 1167.33,
    fill: "#21929b",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1465.43 1308.91 1601.41 1308.91 1530.42 1384.3 1465.43 1308.91",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1543,505.67c-21.15,0-42.28-.59-62.8-1.78a2,2,0,0,1-1.89-2c0-363.32-.31-338.46.63-339.34,1.89-1.79,5.45,1.23,64.06,1.23,138.62,0,255.73-26.26,255.73-57.33a2,2,0,0,1,4,0V444.34C1802.72,478.73,1688.63,505.67,1543,505.67ZM1482.3,500c156.79,8.73,316.42-18.72,316.42-55.67V117.47c-21.38,29-126,50.32-255.73,50.32-20.43,0-40.84-.56-60.69-1.66Z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1656.31,226.39c-16.4,30.08-48.63,44.85-82.55,39.66a151,151,0,0,0,97.06,164.4c60.73-39.65,87-109.25,72.86-180.06C1711.67,258.23,1679.46,248.75,1656.31,226.39Z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1631.26,327.79l36.19,45.62,55.33-101.05-57.42,75.24Z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M850.07,917.24H246.43A12.35,12.35,0,0,1,234.08,906L197.34,501.38a12.39,12.39,0,0,1,12.35-13.52H809.91A12.35,12.35,0,0,1,822.25,499l40.16,404.59A12.41,12.41,0,0,1,850.07,917.24ZM209.69,491.86a8.39,8.39,0,0,0-8.37,9.16L238.07,905.6a8.36,8.36,0,0,0,8.36,7.64H850.07a8.4,8.4,0,0,0,8.36-9.23L818.27,499.43a8.37,8.37,0,0,0-8.36-7.57Z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M371,702.55c-34.19,0-64.59-28.08-67.76-62.56s22-62.46,56.14-62.46,64.53,28,67.76,62.46S405.18,702.55,371,702.55Zm-9.71-104.5c-22.91,0-39.82,18.81-37.68,41.94s22.54,42,45.48,42,39.84-18.84,37.68-42S384.19,598.05,361.28,598.05Z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "373.57 584.85 346.54 584.85 346.89 552.31 367.17 552.31 373.57 584.85",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "356.7 694.4 383.77 694.4 383.43 727.06 363.1 727.06 356.7 694.4",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "420.7 653.24 418.14 625.94 450.76 629.34 452.69 649.83 420.7 653.24",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "309.6 625.94 312.11 653.24 279.49 649.83 277.61 629.34 309.6 625.94",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "398.48 688 415.81 668.68 438.67 694.16 425.66 708.68 398.48 688",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "331.85 591.23 314.51 610.51 291.72 585.09 304.74 570.62 331.85 591.23",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "410.37 610.51 389.45 591.23 412.73 570.62 428.43 585.09 410.37 610.51",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "319.88 668.68 340.8 688 317.46 708.68 301.75 694.16 319.88 668.68",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M451.5,809.22c-22.82,0-43.13-18.77-45.28-41.83s14.64-41.78,37.43-41.78,43.1,18.74,45.28,41.78S474.31,809.22,451.5,809.22Zm-6.56-69.88c-15.3,0-26.57,12.58-25.13,28s15.09,28.07,30.4,28.07,26.58-12.59,25.12-28.07S460.24,739.34,444.94,739.34Z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "453.13 730.51 435.08 730.51 435.29 708.74 448.84 708.74 453.13 730.51",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "441.95 803.77 460.02 803.77 459.82 825.6 446.25 825.6 441.95 803.77",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "484.65 776.25 482.92 758 504.7 760.27 506 773.98 484.65 776.25",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "410.46 758 412.16 776.25 390.38 773.98 389.11 760.27 410.46 758",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "469.83 799.49 481.39 786.58 496.66 803.61 487.98 813.31 469.83 799.49",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "425.28 734.78 413.72 747.68 398.48 730.67 407.16 720.99 425.28 734.78",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "477.72 747.68 463.74 734.78 479.27 720.99 489.77 730.67 477.72 747.68",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "417.36 786.58 431.34 799.49 415.78 813.31 405.28 803.61 417.36 786.58",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "817.09 864.44 538.64 864.44 508.62 548.31 785.88 548.31 817.09 864.44",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M756.52 628.35h-203a5.74 5.74 0 01-5.57-5.13h0a4.56 4.56 0 014.59-5.13h203a5.76 5.76 0 015.58 5.13h0A4.55 4.55 0 01756.52 628.35zM760.72 671.09H557.57A5.75 5.75 0 01552 666h0a4.57 4.57 0 014.6-5.14H759.71A5.77 5.77 0 01765.3 666h0A4.55 4.55 0 01760.72 671.09zM764.92 713.88H561.65a5.76 5.76 0 01-5.58-5.14h0a4.57 4.57 0 014.6-5.14H763.91a5.78 5.78 0 015.6 5.14h0A4.56 4.56 0 01764.92 713.88zM769.13 756.72H565.74a5.75 5.75 0 01-5.58-5.14h0a4.58 4.58 0 014.6-5.15H768.12a5.79 5.79 0 015.6 5.15h0A4.56 4.56 0 01769.13 756.72zM773.34 799.61H569.84a5.75 5.75 0 01-5.59-5.15h0a4.58 4.58 0 014.6-5.15H772.33a5.78 5.78 0 015.6 5.15h0A4.56 4.56 0 01773.34 799.61z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.93,
    cy: 624.37,
    r: 11.18,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630.77,
    cy: 665.96,
    r: 11.18,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.06,
    cy: 708.74,
    r: 11.18,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.6,
    cy: 751.58,
    r: 11.18,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 665,
    cy: 794.46,
    r: 11.18,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M634.71,347.66c-66,0-116.44-59-105.72-124.25a106.9,106.9,0,1,1,211,34.65h0A106.89,106.89,0,0,1,634.71,347.66Zm-.28-209.84A102.91,102.91,0,1,0,736,257.41C746.34,194.6,697.81,137.82,634.43,137.82Z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M634.63,306.93a66.2,66.2,0,1,1,65.16-55.47h0A66.17,66.17,0,0,1,634.63,306.93Zm-.28-128.4a62.2,62.2,0,1,0,61.49,72.28h0A62.2,62.2,0,0,0,634.35,178.53Z",
    className: "color2351fb svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634.48,
    cy: 240.73,
    r: 39.38,
    fill: "#21929b",
    className: "color2351fb svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverseSoftwareDeveloper);
export default __webpack_public_path__ + "static/media/metaverse-software-developer.2ef52da5314271324e91533a9c57bf46.svg";
export { ForwardRef as ReactComponent };